<template>
  <div :class="[hello[index]]">
    aada
  </div>
</template>

<script>

export default {
  name: 'HelloWorld',
  components: {
  },
  data () {
    return {
      hello:['hello','hello1','hello2'],
      index:0
    }
  },
  methods: {
  	
  }
}
</script>

<style scoped>
.hello{color:green}
.hello1{color:red}
.hello2{color:blue}
</style>











// WEBPACK FOOTER //
// src/components/Test.vue